import React from 'react';
import { useTranslation } from 'react-i18next';
import routes from '../../../router/routes';
import useQueryString from '../../../hooks/useQueryString';
import DictionaryList from '../../../containers/shared/DictionaryList';
import { useGetWorkExperienceCategoriesQuery } from '../../../store/apis/dictionaries/work-experience-categories';

const List = () => {
  const [t] = useTranslation();
  const { page = 1, pageSize = 20 } = useQueryString();
  const { data, isLoading, isFetching } = useGetWorkExperienceCategoriesQuery({ page, pageSize });

  return (
    <DictionaryList
      title={t('Категории опыта работы')}
      data={data?.results}
      dataCount={data?.count}
      loading={isLoading || isFetching}
      detailRoute={routes.workExperienceCategories}
    />
  );
};

export default List;
